<template>
  <geometry-container
    v-if="product"
    :product-code="product.code"
    :uid="componentData.uid"
    :content="componentData.content"
  ></geometry-container>
</template>
<script>
import {mapState} from 'vuex';
import GeometryContainer from '@/components/containers/pdp/GeometryContainer.vue';
export default {
  name: 'GeometryComponent',
  components: {
    GeometryContainer,
  },
  props: {
    componentData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('productDetails', ['product']),
  },
};
</script>
